// extracted by mini-css-extract-plugin
var _1 = "SetProgressStandard__avatar--X54tM";
var _2 = "SetProgressStandard__avatarActive--X5h9S";
var _3 = "SetProgressStandard__button--JtpVq SetProgressButton__button--aNy5h";
var _4 = "SetProgressStandard__buttonCell--ywLPQ SetProgressStandard__cell--J7oHb";
var _5 = "SetProgressStandard__cell--J7oHb";
var _6 = "SetProgressStandard__main--AHbdz";
var _7 = "SetProgressStandard__summary--rEaCg SetProgressStandard__button--JtpVq SetProgressButton__button--aNy5h";
export { _1 as "avatar", _2 as "avatarActive", _3 as "button", _4 as "buttonCell", _5 as "cell", _6 as "main", _7 as "summary" }
